import { odds } from '@/lib/format'
import { formatLineSessionDisplayRun } from '@/lib/lineSessionDisplayRun'

/** Lab fancy ticker — runs line as an integer when whole, else trimmed decimal. */
export function formatFancyRuns(runs: number): string {
  if (!Number.isFinite(runs)) return ''
  return Number.isInteger(runs) ? String(runs) : String(runs)
}

/** Betfair line session only — Back/Lay Run from DB line (e.g. 95.5 → 96 / 95). */
export function formatLineSessionRunsForSide(
  runs: number,
  side: string | null | undefined,
): string {
  return formatLineSessionDisplayRun(runs, side) || formatFancyRuns(runs)
}

/**
 * Line Session workstation market (Overs/Runs/Ball Line) — not custom fancy.
 * Do not use `isLineSessionMarket({ marketType: 'fancy' })`; that includes fancy.
 */
export function isLineSessionBetListMarket(marketName: string | null | undefined): boolean {
  const name = String(marketName || '')
    .trim()
    .toLowerCase()
  return (
    name.includes('line session') ||
    name.includes('runs line') ||
    name.includes('overs line') ||
    name.includes('ball line') ||
    /\bline$/.test(name)
  )
}

/**
 * Lab bet-breakdown `fancyOdds(betRate)` for lineLadder: print betRate as-is (2).
 * Custom fancy / match keep previous runs-or-decimal behaviour.
 */
export function workstationOddsPlaced(input: {
  marketName: string
  betRate: number
  runs: number | null
}): string {
  if (isLineSessionBetListMarket(input.marketName)) {
    return formatFancyRuns(input.betRate)
  }
  if (input.runs != null) return formatFancyRuns(input.runs)
  return odds(input.betRate)
}

/** Lab Odds Matched for lineLadder: stored runs with Back/Lay display, not 2. */
export function workstationOddsMatched(input: {
  marketName: string
  runs: number | null
  averagePriceMatched: number
  side?: string | null
}): string {
  if (isLineSessionBetListMarket(input.marketName) && input.runs != null) {
    return formatLineSessionRunsForSide(input.runs, input.side)
  }
  if (input.runs != null) return formatFancyRuns(input.runs)
  return odds(input.averagePriceMatched)
}
